import { render, staticRenderFns } from "./ESGEnterprises.vue?vue&type=template&id=9b4ea0e8&scoped=true"
import script from "./ESGEnterprises.vue?vue&type=script&lang=js"
export * from "./ESGEnterprises.vue?vue&type=script&lang=js"
import style0 from "./ESGEnterprises.vue?vue&type=style&index=0&id=9b4ea0e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b4ea0e8",
  null
  
)

export default component.exports